import script from "./ElCardHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElCardHeader.vue?vue&type=script&lang=ts&setup=true"

import "./ElCardHeader.vue?vue&type=style&index=0&id=7c0d0d8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c0d0d8a"]])

export default __exports__